import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const apiClient = new HttpClient(environment.adminFAPIUrl)

const ENDPOINT = '/v1.0/right'

export const rightService = {
  async getList() {
    return apiClient.get(`${ENDPOINT}/list`)
  },
  async create(data) {
    return apiClient.post(ENDPOINT, {
      body: data,
    })
  },
  async delete(rightId: string) {
    return apiClient.delete(ENDPOINT, {
      params: { rightId },
    })
  },
}
